import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { NextStepManager } from '../../flow-management/NextStepManager';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { setFlow } from '../../store/flow/action-creators';
import { Step } from '../../views/Step';
export const BranchCSFE0014Variant = {
  name: 'BranchCSFE0014Variant',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.CSFE0014);
  },
  rebuildFlow: (_flow, _state, dispatch) => {
    const {
      preVerification,
      postVerification,
      postExistingAccountSelection
    } = getFlowSteps();
    const postVerificationSteps = NextStepManager.addStepsAfterStep(Step.CompanyDomain, Step.CmsSignupIntent, Step.CmsBusinessMaturity)(postVerification);
    const nextSteps = [...preVerification, ...postVerificationSteps];
    dispatch(setFlow(nextSteps, preVerification, postVerificationSteps, [], postExistingAccountSelection));
    return nextSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};